(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  class OrosStoreLocator {
    constructor(section) {
      this.section = section;
      this.form = section.querySelector('[data-store-locator-form]');
      this.input = section.querySelector('[data-store-locator-input]');
      this.suggestions = section.querySelector('[data-store-locator-suggestions]');
      this.status = section.querySelector('[data-store-locator-status]');
      this.list = section.querySelector('[data-store-locator-list]');
      this.mapElement = section.querySelector('[data-store-locator-map]');
      this.dataNode = section.querySelector('[data-store-locator-data]');
      this.stores = JSON.parse(this.dataNode.textContent || '[]').map((store, index) => ({
        ...store,
        lat: Number(store.lat),
        lng: Number(store.lng),
        index
      }));
      this.markers = new Map();
      this.userMarker = null;
      this.selectedPlace = null;
      this.suggestionItems = [];
      this.highlightedSuggestion = -1;
      this.suggestionTimer = null;
      this.suggestionAbortController = null;

      this.bindEvents();
      this.initializeMap();
    }

    bindEvents() {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.findNearest();
      });

      this.input.addEventListener('input', () => {
        this.selectedPlace = null;
        this.queueSuggestions();
      });

      this.input.addEventListener('keydown', (event) => {
        this.handleSuggestionKeys(event);
      });

      document.addEventListener('click', (event) => {
        if (!this.section.contains(event.target)) {
          this.hideSuggestions();
        }
      });

      this.list.addEventListener('click', (event) => {
        const card = event.target.closest('[data-store-id]');
        if (!card) return;
        this.setActiveStore(card.dataset.storeId);
      });
    }

    queueSuggestions() {
      window.clearTimeout(this.suggestionTimer);
      const query = this.input.value.trim();

      if (query.length < 3) {
        this.hideSuggestions();
        return;
      }

      this.suggestionTimer = window.setTimeout(() => {
        this.fetchSuggestions(query);
      }, 260);
    }

    async fetchSuggestions(query) {
      if (this.suggestionAbortController) {
        this.suggestionAbortController.abort();
      }

      this.suggestionAbortController = new AbortController();

      try {
        const results = await this.geocode(query, 5, this.suggestionAbortController.signal);
        this.suggestionItems = results;
        this.highlightedSuggestion = -1;
        this.renderSuggestions(results);
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.hideSuggestions();
        }
      }
    }

    renderSuggestions(results) {
      if (!results.length) {
        this.hideSuggestions();
        return;
      }

      this.suggestions.innerHTML = results.map((result, index) => {
        const placeLabel = this.formatPlaceLabel(result.label);

        return `
          <button class="oros-store-locator__suggestion" type="button" role="option" data-suggestion-index="${index}">
            <strong>${this.escapeHtml(placeLabel.title)}</strong>
            ${placeLabel.detail ? `<span>${this.escapeHtml(placeLabel.detail)}</span>` : ''}
          </button>
        `;
      }).join('');

      this.suggestions.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');

      this.suggestions.querySelectorAll('[data-suggestion-index]').forEach((button) => {
        button.addEventListener('click', () => {
          this.chooseSuggestion(Number(button.dataset.suggestionIndex), true);
        });
      });
    }

    handleSuggestionKeys(event) {
      if (this.suggestions.hidden || !this.suggestionItems.length) {
        return;
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.highlightSuggestion(this.highlightedSuggestion + 1);
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.highlightSuggestion(this.highlightedSuggestion - 1);
      }

      if (event.key === 'Enter' && this.highlightedSuggestion >= 0) {
        event.preventDefault();
        this.chooseSuggestion(this.highlightedSuggestion, true);
      }

      if (event.key === 'Escape') {
        this.hideSuggestions();
      }
    }

    highlightSuggestion(index) {
      const buttons = Array.from(this.suggestions.querySelectorAll('[data-suggestion-index]'));
      if (!buttons.length) return;

      this.highlightedSuggestion = (index + buttons.length) % buttons.length;
      buttons.forEach((button, buttonIndex) => {
        button.classList.toggle('is-highlighted', buttonIndex === this.highlightedSuggestion);
      });
    }

    chooseSuggestion(index, submitAfterSelect) {
      const suggestion = this.suggestionItems[index];
      if (!suggestion) return;

      this.selectedPlace = suggestion;
      this.input.value = suggestion.inputLabel || suggestion.label;
      this.hideSuggestions();

      if (submitAfterSelect) {
        this.findNearest();
      }
    }

    hideSuggestions() {
      this.suggestions.hidden = true;
      this.suggestions.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
      this.highlightedSuggestion = -1;
    }

    async initializeMap() {
      try {
        await this.loadLeaflet();
        this.map = window.L.map(this.mapElement, {
          scrollWheelZoom: false,
          zoomControl: true
        });

        window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; OpenStreetMap'
        }).addTo(this.map);

        this.stores.forEach((store) => this.addStoreMarker(store));
        this.fitStoreBounds();
      } catch (error) {
        this.setStatus("La carte interactive n'a pas pu charger. Les boutons Itinéraire restent disponibles.");
      }
    }

    loadLeaflet() {
      if (window.L) return Promise.resolve();

      if (!document.querySelector('link[data-oros-leaflet-css]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        link.dataset.orosLeafletCss = 'true';
        document.head.appendChild(link);
      }

      if (window.orosLeafletPromise) return window.orosLeafletPromise;

      window.orosLeafletPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Leaflet failed to load'));
        document.head.appendChild(script);
      });

      return window.orosLeafletPromise;
    }

    addStoreMarker(store) {
      const icon = this.createStoreIcon(store.index + 1, false);
      const marker = window.L.marker([store.lat, store.lng], { icon })
        .addTo(this.map)
        .bindPopup(`<strong>${this.escapeHtml(store.name)}</strong><br>${this.escapeHtml(store.address)}`);

      marker.on('click', () => this.setActiveStore(store.id));
      this.markers.set(store.id, marker);
    }

    createStoreIcon(label, active) {
      return window.L.divIcon({
        className: '',
        html: `<div class="oros-store-locator__pin${active ? ' is-active' : ''}"><span>${label}</span></div>`,
        iconSize: [34, 34],
        iconAnchor: [17, 34],
        popupAnchor: [0, -34]
      });
    }

    createUserIcon() {
      return window.L.divIcon({
        className: '',
        html: '<div class="oros-store-locator__user-pin"></div>',
        iconSize: [20, 20],
        iconAnchor: [10, 10]
      });
    }

    fitStoreBounds(extraPoint) {
      if (!this.map || !this.stores.length) return;

      const points = this.stores.map((store) => [store.lat, store.lng]);
      if (extraPoint) points.push([extraPoint.lat, extraPoint.lng]);

      this.map.fitBounds(window.L.latLngBounds(points), {
        padding: [42, 42],
        maxZoom: extraPoint ? 10 : 8
      });
    }

    async findNearest() {
      const query = this.input.value.trim();
      if (!query) {
        this.setStatus("Entrez une adresse, une ville ou un code postal pour lancer la recherche.");
        return;
      }

      this.setStatus('Recherche de votre position...');

      try {
        const position = this.selectedPlace && (this.selectedPlace.label === query || this.selectedPlace.inputLabel === query)
          ? this.selectedPlace
          : await this.geocodeSingle(query);
        if (!position) {
          this.setStatus("Adresse introuvable. Essayez avec la ville et le code postal.");
          return;
        }

        const sortedStores = this.stores
          .map((store) => ({
            ...store,
            distance: this.distanceKm(position.lat, position.lng, store.lat, store.lng)
          }))
          .sort((a, b) => a.distance - b.distance);

        this.renderSortedCards(sortedStores);
        this.setActiveStore(sortedStores[0].id);
        this.showUserPosition(position);
        this.fitStoreBounds(position);
        this.setStatus(`${sortedStores[0].name} est le point de vente le plus proche, à environ ${this.formatDistance(sortedStores[0].distance)}.`);
      } catch (error) {
        this.setStatus("La recherche d'adresse n'est pas disponible pour le moment. Vous pouvez utiliser les boutons Itinéraire.");
      }
    }

    async geocodeSingle(query) {
      const results = await this.geocode(query, 1);
      return results[0] || null;
    }

    async geocode(query, limit, signal) {
      const endpoint = new URL('https://nominatim.openstreetmap.org/search');
      endpoint.searchParams.set('format', 'json');
      endpoint.searchParams.set('limit', String(limit));
      endpoint.searchParams.set('addressdetails', '1');
      endpoint.searchParams.set('countrycodes', 'ca');
      endpoint.searchParams.set('q', query);

      const response = await fetch(endpoint.toString(), {
        headers: { Accept: 'application/json' },
        signal
      });

      if (!response.ok) return [];

      const results = await response.json();
      if (!results.length) return [];

      return results.map((result) => ({
        label: result.display_name,
        inputLabel: this.formatPlaceLabel(result.display_name).inputLabel,
        lat: Number(result.lat),
        lng: Number(result.lon)
      })).filter((result) => Number.isFinite(result.lat) && Number.isFinite(result.lng));
    }

    renderSortedCards(stores) {
      const fragment = document.createDocumentFragment();

      stores.forEach((store) => {
        const card = this.list.querySelector(`[data-store-id="${CSS.escape(store.id)}"]`);
        if (!card) return;

        const distance = card.querySelector('[data-store-distance]');
        if (distance) {
          distance.textContent = `${this.formatDistance(store.distance)} de vous`;
        }

        fragment.appendChild(card);
      });

      this.list.appendChild(fragment);
    }

    setActiveStore(storeId) {
      this.section.querySelectorAll('[data-store-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      const card = this.section.querySelector(`[data-store-id="${CSS.escape(storeId)}"]`);

      if (card) card.classList.add('is-active');

      this.markers.forEach((marker, id) => {
        const store = this.stores.find((item) => item.id === id);
        if (!store) return;
        marker.setIcon(this.createStoreIcon(store.index + 1, id === storeId));
      });

      const activeMarker = this.markers.get(storeId);
      if (activeMarker && this.map) {
        activeMarker.openPopup();
        this.map.panTo(activeMarker.getLatLng(), { animate: true });
      }
    }

    showUserPosition(position) {
      if (!this.map) return;

      if (this.userMarker) {
        this.userMarker.setLatLng([position.lat, position.lng]);
        return;
      }

      this.userMarker = window.L.marker([position.lat, position.lng], {
        icon: this.createUserIcon(),
        zIndexOffset: 1000
      }).addTo(this.map).bindPopup('Votre position approximative');
    }

    setStatus(message) {
      this.status.textContent = message;
    }

    distanceKm(lat1, lng1, lat2, lng2) {
      const radius = 6371;
      const dLat = this.toRadians(lat2 - lat1);
      const dLng = this.toRadians(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return radius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    toRadians(value) {
      return value * Math.PI / 180;
    }

    formatDistance(distance) {
      if (distance < 10) return `${distance.toFixed(1)} km`;
      return `${Math.round(distance)} km`;
    }

    formatPlaceLabel(label) {
      const parts = String(label).split(',').map((part) => part.trim()).filter(Boolean);
      let title = parts.shift() || String(label);

      if (/^\d+$/.test(title) && parts.length) {
        title = `${title} ${parts.shift()}`;
      }

      const detail = parts.join(', ').trim();

      return {
        title,
        detail,
        inputLabel: detail ? `${title}, ${detail}` : title
      };
    }

    escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[char]);
    }
  }

  document.querySelectorAll('[data-store-locator]').forEach((section) => {
    new OrosStoreLocator(section);
  });

  } catch(e) { console.error(e); }
})();
})();
